<template>
  <invest020 />
</template>

<script>
import invest020 from '@/pages/invest/p_invest020.vue';

export default {
  components: {
    invest020
  }
};
</script>
